module.exports = __webpack_public_path__ + "static/media/logo.f1c5515c.svg";